export const message={
    loginSuccess:"Successfully Logged In",
    requiredFied:"This field is required",
    newPasswordRequiredMessage:"New Password is required",
    profilePictureLimitMessage:'File size should not exceed 2MB',
    errorMessage:"Some error occured.Please try again",
    passwordRequiredMessage:"Password is required",
    passwordMinMessage:"Password must be at least 8 characters long",
    passwordMatchMessage:"Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character",
    matchMessage:'Passwords should match',
    emailRequiredMessage:"Email is required",
    invalidEmailMessage:"Invalid email format",
    nameRequiredMessage:"Name is required",
    nameMatchMessage:"Name must contain only alphabets and spaces",
    confirmPasswordRequiredMessage:"Confirm Password is required",
    LogoutMessage:"You have been logged out",
    careerPageCopyMessage:"Career page link copied!",
    subscribeMessage:"Upgrade your account to create team",
    postMessgae:"Upgrade your account to post jobs",
    fileUploadeErrorMessage:"Please upload a PDF, DOC, or DOCX file."
}